module.exports = __webpack_public_path__ + "img/icon_change_arrow_pc.9cd55b0e.svg";